export interface Customers {
  id: number;
  name: string;
}

export interface Dentist {
  id: number;
  name: string;
}

export interface Procedure {
  id: number;
  name: string;
  value: number;
}

export interface TreatmentPlanItem extends Procedure {
  tooth: number;
  face: string;
  currentState: string;
}

export type ArcadaType =
  | 'adultoCima'
  | 'adultoBaixo'
  | 'criancaCima'
  | 'criancaBaixo';

export interface Tooth {
  id: number;
  updated: 0 | 1;
  type: ArcadaType;
  numTooth: number;
  classes: { [key: string]: string };
  currentState: number;
  face: string | null;
}

export interface OdontogramState {
  adultoCima: Tooth[];
  adultoBaixo: Tooth[];
  criancaCima: Tooth[];
  criancaBaixo: Tooth[];
}

export type OdontogramAction =
  | { type: 'SET_ARCADAS'; payload: OdontogramState }
  | { type: 'UPDATE_DENTE'; payload: { arcada: ArcadaType; dente: Tooth } };

export interface ModalData {
  dente: Tooth;
  face: string;
  estadoAtual: string;
  valor: number;
}

export enum ToothCondition {
  AMALGAMA = 1,
  CARIES = 2,
  ENDODONTIA = 3,
  AUSENTE = 4,
  RESINA = 5,
  IMPLANTE = 6,
  SELANTE = 7,
  COROA = 8,
  LIMPAR = 9,
  OUTROS = 11,
}

export type PaintCondition = Exclude<ToothCondition, ToothCondition.LIMPAR>;

export const conditionConfig: Record<
  PaintCondition,
  { nome: string; classe: string }
> = {
  [ToothCondition.AMALGAMA]: { nome: 'Amálgama', classe: 'marcadoVermelho' },
  [ToothCondition.CARIES]: { nome: 'Cáries', classe: 'marcadoAmarelo' },
  [ToothCondition.ENDODONTIA]: { nome: 'Endodontia', classe: 'marcadoLaranja' },
  [ToothCondition.AUSENTE]: { nome: 'Ausente', classe: 'marcadoTomate' },
  [ToothCondition.RESINA]: { nome: 'Resina', classe: 'marcadoMarrom' },
  [ToothCondition.IMPLANTE]: { nome: 'Implante', classe: 'marcadoRoxo' },
  [ToothCondition.SELANTE]: { nome: 'Selante', classe: 'marcadoVerde' },
  [ToothCondition.COROA]: { nome: 'Coroa', classe: 'marcadoAzul' },
  [ToothCondition.OUTROS]: { nome: 'Outros', classe: 'marcadoVerdeClaro' },
};
